import React from "react"

const UnidataResult = (props) => {
    const details = props.data.Unidata.details;
    const address = props.address;

    const setServiceString = (service) => {
        return service === 'UN' ? "UN - FTTC/ADSL" : "UF - FIBRA"
    } 

    return(
        (details.length > 1) ? (
            <div>
                <h3 style={{textAlign: 'center'}}>Civici e scale</h3>
                <ul style={{fontSize: '23px', listStyleType: 'none', paddingLeft: '0', maxHeight: '150px', padding: '10px', overflowY: 'scroll', width: '60%', margin: 'auto'}}>
                    {details.map((item, index) => (
                        <li key={index} style={{color: '#a6acaf', width: '95%', display: 'flex', margin: 'auto', marginBottom: '5px', border: '1px solid grey', padding: '2px', paddingInline: '5px'}}>
                            {`${address} ${item.Civico} ${item.Scala_Palazzina}`}
                        </li>
                    ))}
                </ul>
            </div>
        )
        :
        (
            <div style={{width: '60%', margin: 'auto'}}>
                <h2 style={{textAlign: 'center'}}>Dettagli</h2>
                <table style={{border: '1px solid #dee2e6'}} className="dataTable">
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>POP</td>
                        <td>{details[0].POP}</td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Servizio</td>
                        <td>{setServiceString(details[0].Servizio)}</td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Stato</td>
                        <td>{details[0].Stato_Building}</td>
                    </tr>
                    <tr>
                        <td style={{fontWeight: 'bold', color: 'rgb(95, 106, 106)'}}>Descrizione</td>
                        <td>{details[0].Descrizione_Stato}</td>
                    </tr>
                </table>
            </div>
        )
    )
}

export default UnidataResult;